<template>
  <tk-flex
    column
    style="padding: 60px;"
    :style="{width: width * 2 + 'px',height: height * 2 + 'px'}"
  >
    <tk-flex class="full-width" center middle :style="`height: ${width * 2 - 120}px`">
      <tk-image :oraign="true" :quality="85" :src="commodity.img[0]" style="width: 100%;" />
    </tk-flex>
    <div class="poster-text line-clamp-2">{{ commodity.commodity }}</div>
    <tk-flex style="margin-top: 30px;">
      <tk-image
        class="flex-shrink-0"
        :oraign="true"
        :quality="85"
        style="width: 160px;height: 160px;"
        :src="qrCodeImage"
      />
      <tk-flex
        column
        middle
        class="full-width fill m-l-10"
        style="height: 160px; margin-left: 20px;"
      >
        <div class="font-bold" style="font-size: 32px;">有光万物</div>
        <div class style="color: #666666;margin-top: 20px;font-size: 28px">长安识别二维码</div>
      </tk-flex>
    </tk-flex>
  </tk-flex>
</template>
<script>
export default {
  data () {
    return {
      width: 375,
      height: 812,
      getParams: [],
      commodity: {
        img: []
      }, // 商品数据
      qrCodeImage: '' // 小程序二维码
    }
  },
  mounted () {
    this.init()
    this.getCommodity() // 获取商品数据
    this.getQrcode() // 生成二维码
  },
  computed: {
    //   // 0 用户id ，1 设备宽， 2设备高， 3商品id
  },
  methods: {
    init () {
      this.getParams = this.$route.query.params.split(',')
      this.width = this.getParams[1]
      this.height = this.getParams[2]
    },
    async getCommodity () {
      // const user = await this.$tkParse.get(`https://cloud.light.mokekeji.com/classes/_User/${this.$route.query.shareId}`).catch(e => {
      //   return { data: null }
      // })
      const res = await this.$tkParse.get(`https://cloud.light.mokekeji.com/classes/commodity/${this.getParams[3]}`)
      this.commodity = res.data
      this.$forceUpdate()
    },
    // 生成小程序二维码
    async getQrcode () {
      let res = await this.$tkParse.post('https://cloud.light.mokekeji.com/index/getWxacode', {
        params: this.getParams[0],
        commodity: this.getParams[3]
      }).catch(e => {
        return { data: { url: null } }
      })
      console.log(res.data)
      this.qrCodeImage = res.data.url || ''
      this.$forceUpdate()
    }

  }
}
</script>
<style lang="scss">
.poster-text{
  font-size: 28px;
  margin-top: 30px;
}
// 只显示两行超出隐藏
.line-clamp-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
